<template>
  <div class="col-12" style="overflow:auto;max-width: 60em;margin: auto;">
    <card id="order-med-card" class="mt-2" style="border-radius: 24px" card-body-classes="pt-0" :style="{ 'background-color': training.backgroundColor }">
      <h5 slot="header" class="card-title" style="font-weight: 500;color: #fff;font-weight: 600;">
        {{ training.title }}
      </h5>
      <div class="pb-3" style="margin-top: 2.5em;">
        <div style="width: fit-content;background: #fff;padding: 0.5em 1em;border-radius: 2em;font-size: 0.8em;display: flex;align-items: center;">
          <radial-progress-bar style="display: inline-block;" :diameter="20" :completed-steps="completedDays" :total-steps="training.days.length" :innerStrokeWidth="2" :strokeWidth="2">
          </radial-progress-bar> <span style="margin-left: 0.5em;color:#adadad;">{{ displayDaysLeft() }}</span>
        </div>
      </div>

      <dynamic-image v-if="training.image" :file-id="training.image" image-style="position: absolute;
    height: 100%;
    top: 0px;
    inset-inline-end: 0px;padding: 0.5rem;">
      </dynamic-image>
    </card>
    <el-timeline style="height: 70vh;overflow: auto;padding-bottom: 3em;max-width: 50em;margin: auto;padding-left: 1em;padding-right: 1em;">
      <el-timeline-item placement="top" v-for="(day, index) in days" :key="day.name">
        <el-card style="border-radius: 1em">
          <div class="row">
            <div class="col-6">
              <div class="col-12" style="display: flex;justify-content: start;align-items: center;font-size: 1.5em;font-weight: 600;padding: 0px;">
                {{ day.name }}
              </div>
              <div class="col-12" style="display: flex;justify-content: start;align-items: center;padding: 0px;">
                {{ getDurationForDay(day) }} {{ $t("message.minutes") }}
              </div>
            </div>
            <div class="col-6" v-if="completedDays > index" style="display: flex;justify-content: end;align-items: center;">
              <i class="fas fa-check"></i>
            </div>
            <div class="col-6" v-if="completedDays == index" style="display: flex;justify-content: end;align-items: center;">
              <n-button type="primary" :size="'md'" round @click.native="startTrainingDay(index)" style="font-weight: 600;margin: 0px;">
                {{ $t("message.START") }}
              </n-button>
            </div>
          </div>
        </el-card>
      </el-timeline-item>
    </el-timeline>
    <modal :show.sync="showTimeModal" headerclasses="justify-content-center" class="time-action-modal" footerClasses="justify-content-center" modalContentClasses="time-action-modal-content" :showClose="false" :animationDuration="250">
      <h5 slot="header" class="title title-up">
        {{$t('message.Select Time')}}
      </h5>
      <div style="width: 100%;height: 18vh;overflow: scroll;padding: 0 0.5em;overflow-x: hidden;">
        <div class="col-12" style="width: 100;overflow: scroll;padding:0px;text-align:center">
          <div class="col-6" style="padding: 0px;    display: inline-block;">
            <vue-datetime v-model="time" type="time" format="hh:mm a" :minute-step="10" :auto="true" :use12-hour="true" :backdrop-click="false" :phrases="{ ok: $t('message.OK'), cancel: $t('message.Cancel') }" input-class="form-control"></vue-datetime>
          </div>
        </div>
        <div class="col-12">
          <p>Notifications will be sent at this time.</p>
        </div>
        <!-- <div class="col-12" style="padding: 0px;text-align:center">
          <n-button type="primary" round size="sm" @click.native="setReminder">
            Set
          </n-button>
        </div> -->
      </div>
    </modal>
    <div class="col-12 pl-0" style="text-align:center;position: fixed;bottom: 0px;" v-if=" isCordovaPresent && displayDaysLeft() != 'Completed'">
      <n-button type="primary" round size="sm" @click.native="showTimeModal=true" v-if="!isRemindersSet">
        <i class="fa fa-plus"></i>
        {{ $t('message.Set Reminders')}}
      </n-button>
      <n-button type="primary" round size="sm" @click.native="resetReminders" v-else>
        <i class="fas fa-sync-alt"></i>
        {{ $t('message.Reset Reminders')}}
      </n-button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import RadialProgressBar from "vue-radial-progress";
export default {
  name: "fitnessschedule",

  created() { },

  data() {
    return {
      completedDays: 0,
      days: [],
      trackingDetails: null,
      showTimeModal: false,
      time: new Date(new Date().setHours(9, 0, 0, 0)).toISOString(),
      isRemindersSet: false,
    };
  },

  components: {
    RadialProgressBar,
  },

  async mounted() {
    this.$root.onBackButton = () => {
      this.$router.push("/fitnesssets");
    };
    try {
      this.trackingDetails = await this.$store.dispatch("getTrackingDetails", {
        patientId: this.user._id,
        trainingId: this.training._id,
      });
    } catch (error) {
      console.log(error);
    }

    this.days = this.training.days;

    if (
      this.trackingDetails &&
      this.trackingDetails.trainingTracker &&
      this.trackingDetails.trainingTracker.daysTracker
    ) {
      let lastTrackedDay =
        this.trackingDetails.trainingTracker.daysTracker[
        this.trackingDetails.trainingTracker.daysTracker.length - 1
        ];

      if (
        this.days[lastTrackedDay.day - 1].exercises.length ==
        lastTrackedDay.exerciseTracker.length &&
        lastTrackedDay.exerciseTracker[
          lastTrackedDay.exerciseTracker.length - 1
        ].latestStatus == "COMPLETED"
      ) {
        this.completedDays =
          this.trackingDetails.trainingTracker.daysTracker.length;
      } else {
        this.completedDays =
          this.trackingDetails.trainingTracker.daysTracker.length - 1;
      }
    }

    if (window.cordova) {
      this.getReminders();
    }
  },

  beforeDestroy() {
    this.$root.onBackButton = null;
  },

  computed: {
    ...mapState({
      training: (state) => state.training,
    }),
    isCordovaPresent() {
      return window.cordova ? true : false;
    },
    user() {
      if (localStorage.user) {
        return JSON.parse(localStorage.user);
      }
    },
  },

  methods: {
    getDurationForDay(day) {
      let totalDuration = day.exercises.reduce((sum, exercise) => {
        return (sum += exercise.duration);
      }, 0);
      return totalDuration;
    },
    startTrainingDay(dayIndex) {
      this.$store.commit("setState", {
        stateName: "currentTrainingDayIndex",
        stateValue: dayIndex,
      });
      this.$router.push("/training");
    },
    displayDaysLeft() {
      let displayDaysLeft = this.training.days.length - this.completedDays;
      if (displayDaysLeft == 0) {
        return this.$t("message.Completed");
      } else if (displayDaysLeft == 1) {
        return displayDaysLeft + " " + this.$t("message.Days left");
      } else {
        return displayDaysLeft + " " + this.$t("message.Days left");
      }
    },
    setReminder() {
      let time = {
        hour: new Date(this.time).getHours(),
        minute: new Date(this.time).getMinutes(),
      };
      let title = `Fitness - ${this.training.title}`;
      let text = `Start ${this.training.days[0].name} workout`;
      if (this.completedDays > 0) {
        text = `Continue workout for ${this.training.days[this.completedDays].name
          }`;
      }
      let data = "fitness notification";
      localStorage[title] = JSON.stringify(time);
      this.showTimeModal = false;
      let id = 0;
      if (localStorage.remindersId) {
        id = Number(localStorage.remindersId);
      }
      //schedule fitness local notification
      cordova.plugins.notification.local.schedule(
        {
          title: title,
          text: text,
          id: id,
          trigger: { every: time },
          foreground: true,
          autoClear: false,
          data: data,
        },
        () => {
          swal.fire({
            title: "Reminders added!",
            type: "success",
          });
          this.getReminders();
        }
      );
      id++;
      localStorage.remindersId = id;
    },
    getReminders() {
      this.isRemindersSet = false;
      cordova.plugins.notification.local.getScheduled((res) => {
        for (let notification of res) {
          if (notification.title == `Fitness - ${this.training.title}`) {
            this.isRemindersSet = true;
            break;
          }
        }
        if (!this.isRemindersSet) {
          localStorage.removeItem(`Fitness - ${this.training.title}`);
        }
      });
    },
    resetReminders() {
      swal
        .fire({
          title: "Are you sure that you want to remove reminders?",
          confirmButtonText: "yes",
          showCancelButton: true,
          cancelButtonText: "No",
        })
        .then(async (result) => {
          if (result && result.value) {
            //cancel fitness local notifications
            cordova.plugins.notification.local.getScheduled((res) => {
              for (let notification of res) {
                if (notification.title == `Fitness - ${this.training.title}`) {
                  cordova.plugins.notification.local.cancel(
                    notification.id,
                    (res) => {
                      console.log("cancel", res);
                    }
                  );
                }
              }
              localStorage.removeItem(`Fitness - ${this.training.title}`);
              swal.fire({
                title: "Reminders removed!",
                type: "success",
              });
              this.getReminders();
            });
          }
        });
    },
  },
};
</script>

<style scoped>
/deep/ .el-card__body {
  text-align: center;
  position: relative;
}

/deep/ .el-timeline-item__timestamp {
  font-size: 1.1rem;
  text-transform: uppercase;
}

/deep/.time-action-modal:not(.d-none) {
  display: flex !important;
  align-items: end;
}

/deep/.time-action-modal .modal-dialog {
  width: 100%;
  margin: 0;
  border-top-right-radius: 24px;
  border-top-left-radius: 24px;
  overflow: hidden;
}

/deep/.time-action-modal-content {
  /* height: 98vh; */
}
</style>
